import {sendAmplitudeEvent} from '#/analytics/amplitude-events';
import {ActionMenuContext} from '#/components/actionmenu/action-menu';
import {
  ActionMenuHeader,
  ActionMenuHeaderButton,
  ActionMenuHeaderIcons,
} from '#/components/actionmenu/action-menu-header';
import {ActionMenuLayoutFooter} from '#/components/actionmenu/action-menu-layout';
import {
  ActionMenuControlledTabsContent,
  ActionMenuControlledTabsList,
  ActionMenuControlledTabsRoot,
} from '#/components/actionmenu/action-menu-tabs';
import {ActionMenuInformationActivityTab} from '#/components/actionmenu/sections/information/action-menu-information-activity-tab';
import {ActionMenuInformationCommunityTab} from '#/components/actionmenu/sections/information/action-menu-information-community-tab';
import {ActionMenuInformationInfoTab} from '#/components/actionmenu/sections/information/action-menu-information-info-tab';
import {ActionMenuSection} from '#/components/actionmenu/types';
import AsyncButton from '#/components/async-button/component';
import {useModalContext} from '#/contexts/modal-provider';
import {useQueryNavigationActions} from '#/hooks/use-query-navigation-actions';
import {InformationTab} from '#/navigation/tabs';
import {DefaultChildren} from '#/utils/utils';
import {InformationCircleIcon, ListBulletIcon, UserGroupIcon} from '@heroicons/react/24/solid';
import {FunctionComponent, useContext} from 'react';
import {useTranslation} from 'react-i18next';

export const ActionMenuInformation: FunctionComponent<DefaultChildren> = () => {
  const {t} = useTranslation('translation');
  const {open} = useModalContext();

  const {land, landMarketInfo, landAccountInfo} = useContext(ActionMenuContext);

  const {
    actionMenu: {close, openTrade, openRent},
  } = useQueryNavigationActions();

  const onRentButtonClick = () => {
    if (!landAccountInfo) {
      open({name: 'LoginModal', props: {}});
      return;
    }
    openRent(undefined, undefined, ActionMenuSection.INFORMATION);
  };
  const onTradeButtonClick = () => {
    sendAmplitudeEvent.tradeButtonClick();
    if (!landAccountInfo) {
      open({name: 'LoginModal', props: {}});
      return;
    }
    openTrade(undefined, undefined, ActionMenuSection.INFORMATION);
  };

  return (
    <ActionMenuControlledTabsRoot
      queryParamTabKey='informationTabId'
      tabKeys={InformationTab}
      data={[
        {
          value: InformationTab.INFORMATION,
          name: t('pages.actionMenu.information.sections.information.title'),
          IconComponent: InformationCircleIcon,
          ContentComponent: ActionMenuInformationInfoTab,
        },
        {
          value: InformationTab.COMMUNITY,
          name: t('pages.actionMenu.information.sections.community.title'),
          IconComponent: UserGroupIcon,
          ContentComponent: ActionMenuInformationCommunityTab,
        },
        {
          value: InformationTab.ACTIVITY,
          name: t('pages.actionMenu.information.sections.activity.title'),
          IconComponent: ListBulletIcon,
          iconColorClassName: 'fill-white stroke-white',
          ContentComponent: ActionMenuInformationActivityTab,
        },
      ]}
    >
      <ActionMenuHeader land={land} landMarketInfo={landMarketInfo}>
        <ActionMenuHeaderButton onClick={close}>
          <ActionMenuHeaderIcons.Close />
        </ActionMenuHeaderButton>
      </ActionMenuHeader>

      <ActionMenuControlledTabsList />
      <ActionMenuControlledTabsContent />
      <ActionMenuLayoutFooter variant='normal'>
        <AsyncButton variant='hollow' isLoading={false} disabled={false} onClick={onRentButtonClick}>
          {t('actions.rent')}
        </AsyncButton>
        <AsyncButton variant='regular' isLoading={false} disabled={false} onClick={onTradeButtonClick}>
          {t('pages.actionMenu.information.ctaBottomButtonTrade')}
        </AsyncButton>
      </ActionMenuLayoutFooter>
    </ActionMenuControlledTabsRoot>
  );
};
